import { render, staticRenderFns } from "./InviteLinkExpired.vue?vue&type=template&id=32e121f1&scoped=true"
import script from "./InviteLinkExpired.vue?vue&type=script&lang=js"
export * from "./InviteLinkExpired.vue?vue&type=script&lang=js"
import style0 from "./InviteLinkExpired.vue?vue&type=style&index=0&id=32e121f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e121f1",
  null
  
)

export default component.exports